import { useEffect } from 'react';

import { showErrorToast } from 'components/toast/toast';
import { createLocale } from 'locales';

const localize = createLocale('global');

const useErrorToast = (error: Error | null): void => {
  useEffect(() => {
    if (error) {
      showErrorToast({
        description: error.message ?? localize('unknownError'),
        title: localize('somethingWentWrong'),
      });
    }
  }, [error]);
};

export default useErrorToast;
